// Other
import React from "react";
import { Link } from "react-router-dom";

const Button = ({ title, Icon, location, action }) => {
  return (
    <Link
      to={location ? location : "#"}
      className="flex py-1.5 px-4 rounded text-white bg-brand-500 hover:bg-brand-700 cursor-pointer w-max"
      onClick={action}
    >
      <span>{title}</span>
      {Icon ? (
        <Icon size={25} color="#fff" weight="bold" className="ml-1" />
      ) : (
        <></>
      )}
    </Link>
  );
};

export default Button;
